<template>
    <FormSection title="Physician Information" :full-height="false" :application-id="referral.application">
        <template #content>
            <section class="row g-0 p-4 pb-0">
                <div
                    class="col-12 row g-0 border-bottom"
                    v-for="(physicianRequired, index) in referral.physicianRequiredArray"
                    :key="index"
                >
                    <div class="col-12 d-flex align-items-center" with.bind="physicianRequired">
                        <CreatePhysicianRow
                            :physician-required="physicianRequired"
                            :physician-index="index"
                            :referral="referral"
                        />
                        <div class="col-5 col-lg-7 p-1 pt-4" v-if="index == 0">
                            <i class="fa fa-plus fa-2x text-success" @click="addPhysician()"></i>
                        </div>
                        <div class="col-5 col-lg-7 p-1 pt-4" v-if="index != 0">
                            <i class="fa fa-times fa-2x text-danger" @click="removePhysician(index)"></i>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form-group col-12 col-md-5 col-lg-4">
                            <div class="form-check custom-checkbox custom-border physician-required-section">
                                <input
                                    type="checkbox"
                                    :id="`ref-source-${index}`"
                                    ref="radio"
                                    class="form-check-input au-target physician-required-input"
                                    @change="radioChanged(index)"
                                />
                                <label class="form-check-label" :for="`ref-source-${index}`">
                                    <span class="ms-2"> Referral Source</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </template>
    </FormSection>
</template>

<script lang="ts" src="./CreatePhysician.ts"></script>
<style src="./CreatePhysician.scss"></style>
